// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
};

const DeleteCard = (props: Props) => {
  const {
    visible,
    close,
    submit,
  } = props;

  const deleteSelectedCard = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedCard} type="danger">Delete</SpButton>,
      ]}
      title="Delete Debit Card"
    >
      <div className="px-4">
        <div className="mt-1">Are you sure you want to delete this card?</div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteCard;
